











































import { Component, Mixins } from "vue-property-decorator";
import { GlobalMixin } from "@/mixins/global";
import OtherModulesChild from "@/components/OtherModulesChild.vue";
import { ModuleChild } from "@/interfaces/general";

@Component({
  components: { OtherModulesChild },
  computed: {},
  methods: {}
})
export default class OtherModules extends Mixins(GlobalMixin) {
  content: ModuleChild[] = [
    {
      image: "otherModules/Production Schedule.svg",
      content: "Production Schedule Manager",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/OPEX.svg",
      content: "OPEX Budget Builder",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Integrate Communication.svg",
      content: "Integrated Communication System",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Action Tracker.svg",
      content: "Consolidated Action Tracker",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Internal Travel.svg",
      content: "Internal Travel / Logistics Manager",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/access manager.svg",
      content: "Site Access Form Manager",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Group Roster.svg",
      content: "Group Roster Manager",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/R&R.svg",
      content: "R&R Governance",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Professional Development.svg",
      content: "Professional Development Manager",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Mobile prestar.svg",
      content: "Mobile Prestart app",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/Library Document.svg",
      content: "Endevour Document Library",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    },
    {
      image: "otherModules/AFE.svg",
      content: "Projects Management and AFE Submissions",
      link: process.env.VUE_APP_UNDER_CONSTRUCTION
    }
  ];
}
